/* eslint-disable react/no-array-index-key */
import React from 'react';
import { Link, useLocation, useHistory } from 'react-router-dom';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import Text from '@/v1/components/atoms/Text';
import Button from '@/v1/components/atoms/Button';
import HotspotSmall from '@/v1/components/atoms/Icon/HotspotSmall';

import './BurgerMenuItem.scss';

const propTypes = {
    active: PropTypes.bool,
    title: PropTypes.string,
    subtext: PropTypes.string,
    cta: PropTypes.object,
    ctaCallback: PropTypes.func,
};

const defaultProps = {
    active: false,
    title: null,
    subtext: null,
    cta: null,
    ctaCallback: null,
};

const BurgerMenuItem = (props) => {
    const { active, title, subtext, cta, ctaCallback, submenu, submenuheading } = props;

    const classes = classNames({
        BurgerMenuItem: true,
        'BurgerMenuItem--active': active,
    });
    const ctaVariant = active ? 'secondary-gold' : 'secondary-light';

    const location = useLocation();
    const history = useHistory();

    const subRoute = location.hash.slice(1);

    const onSubMenuClick = (e, item) => {
        e.preventDefault();

        // Force a route change
        history.push('/');

        setTimeout(() => {
            history.push(`${cta.route}#${item.name}`);
            ctaCallback();
        }, 1);
    };

    const word = (title && title.split('<br>')) || [''];
    const burgerTitle = word.join('\r\n');

    return (
        <div className={classes}>
            <div className="BurgerMenuItem__menu">
                <div className="BurgerMenuItem__group">
                    <Text className="BurgerMenuItem__pre" component="h5">
                        {subtext}
                    </Text>
                    <Text className="BurgerMenuItem__title" component="h2">
                        {burgerTitle}
                    </Text>
                </div>
                <Link to={cta.route} onClick={ctaCallback}>
                    <Button className="BurgerMenuItem__cta" type="button" variant={ctaVariant} icon={false}>
                        {cta.text}
                    </Button>
                </Link>
            </div>
            <div className="BurgerMenuItem__submenu">
                {submenu.length > 0 && (
                    <>
                        <Text className="BurgerMenuItem__submenu-item-header" component="h5">
                            {submenuheading}
                        </Text>
                        <div className="BurgerMenuItem__submenu-items">
                            {submenu.map((item) => {
                                const iconVariant = subRoute.toLowerCase() === item.name.toLowerCase() ? 'icon-secondary-gold' : 'icon-light';

                                return (
                                    <div className="BurgerMenuItem__submenu-item">
                                        <Link to={`${cta.route}#${item.name}`} onClick={(e) => onSubMenuClick(e, item)}>
                                            <Button variant={iconVariant} className="BurgerMenuItem__submenu-item-cta" icon={<HotspotSmall />} type="button">
                                                {item.label}
                                            </Button>
                                        </Link>
                                    </div>
                                );
                            })}
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

BurgerMenuItem.propTypes = propTypes;
BurgerMenuItem.defaultProps = defaultProps;

export default BurgerMenuItem;
